import { __decorate } from "tslib";
import { Route } from '../core';
import config from '@api/config';
var CheckoutStage = /*@__PURE__*/ (function () {
    function CheckoutStage() {
    }
    CheckoutStage.post = function (response) {
        return response;
    };
    CheckoutStage = __decorate([
        Route(config.CHECKOUT_ENDPOINT, true, true)
    ], CheckoutStage);
    return CheckoutStage;
}());
export { CheckoutStage };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/endpoints/checkout-stage.ts
// module id = null
// module chunks = 